import { getUsers } from "../util/API/customers";

export const crmTable = {
    services: getUsers,
    rowsPerPage: 5,
    filters: [
        "country",
        "status",
        "role"
    ],
    columns: [
        {
            header: "",
            dataType: "pfp",
            source: "photo",
            sortable: false,
            width: 50,
            headerAlignment: "left",
            cellAlignment: "left",
        },
        {
            header: "First Name",
            dataType: "string",
            source: "firstName",
            sortable: false,
            width: 500,
            headerAlignment: "left",
            cellAlignment: "left",
        },
        {
            header: "Country",
            dataType: "country",
            source: "countryid",
            sortable: false,
            width: 200,
            headerAlignment: "left",
            cellAlignment: "left",
        },
        {
            header: "Email",
            dataType: "string",
            source: "emailAccount",
            sortable: false,
            width: 200,
            headerAlignment: "left",
            cellAlignment: "left",
        },
        {
            header: "Phone",
            dataType: "string",
            source: "telephoneno",
            sortable: false,
            width: 150,
            headerAlignment: "left",
            cellAlignment: "left",
        },
        {
            header: "User Status",
            dataType: "string",
            source: "profilestatus",
            sortable: false,
            width: 150,
            headerAlignment: "left",
            cellAlignment: "left",
        },
        {
            header: "Address",
            dataType: "string",
            source: "cityname",
            sortable: false,
            width: 200,
            headerAlignment: "left",
            cellAlignment: "left",
        },
        {
            header: "Edit",
            dataType: "edit",
            source: "name",
            sortable: false,
            width: 100,
            headerAlignment: "right",
            cellAlignment: "right",
        },
    ]
}